var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationCity = function SvgLocationCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.02 20.577v-13.5h5.23V4.442L12 1.75l2.75 2.692v6.635h5.23v9.5zm1.5-1.5h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm5.23 8h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm5.23 12h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5z"
  })));
};
export default SvgLocationCity;